import { Tooltip, TooltipProps } from '@mui/material';

import styled from 'styled-components';

const StyledTooltip = styled(Tooltip)`
  text-decoration: underline dashed;
  text-underline-offset: ${({ theme }) => theme.spacing(0.5)};
  cursor: pointer;
`;

export const PropertyDetailsTooltip = ({ children, ...tooltipProps }: TooltipProps) => {
  // Span element needed for tooltip to work properly with FormattedMessage
  return (
    <StyledTooltip {...tooltipProps}>
      <span>{children}</span>
    </StyledTooltip>
  );
};
